import { Sparkles } from "lucide-react"

const VerifiedUserCheck = ({ }) => {
    return (<div className="absolute top-4 right-4 z-20 flex items-center gap-1 bg-gradient-to-r from-emerald-400 to-teal-400 text-white px-3 py-1 rounded-full text-sm font-medium">
        <Sparkles className="h-4 w-4" />
        Verified user
    </div>)
}
export default VerifiedUserCheck;